module.exports = __webpack_public_path__ + "img/img5.d8d3ec46.png";